// extracted by mini-css-extract-plugin
module.exports = {"view":"view-module--view--20ZCA"};